/**
 * Account General Info Form Options
 * Provides translated option sets for form dropdowns
 */

// Language options
export const getLanguageOptions = (t: (key: string) => string) => [
  {
    value: 'de',
    label: t('languages.de'),
  },
  {
    value: 'en',
    label: t('languages.en'),
  },
  {
    value: 'fr',
    label: t('languages.fr'),
  },
  {
    value: 'it',
    label: t('languages.it'),
  },
];

// Canton options (Swiss specific)
export const getCantonOptions = (t: (key: string) => string) => [
  {
    value: 'ZH',
    label: t('cantons.zurich'),
  },
  {
    value: 'BE',
    label: t('cantons.bern'),
  },
  {
    value: 'LU',
    label: t('cantons.lucerne'),
  },
  {
    value: 'UR',
    label: t('cantons.uri'),
  },
  {
    value: 'SZ',
    label: t('cantons.schwyz'),
  },
  {
    value: 'OW',
    label: t('cantons.obwalden'),
  },
  {
    value: 'NW',
    label: t('cantons.nidwalden'),
  },
  {
    value: 'GL',
    label: t('cantons.glarus'),
  },
  {
    value: 'ZG',
    label: t('cantons.zug'),
  },
  {
    value: 'FR',
    label: t('cantons.fribourg'),
  },
  {
    value: 'SO',
    label: t('cantons.solothurn'),
  },
  {
    value: 'BS',
    label: t('cantons.baselStadt'),
  },
  {
    value: 'BL',
    label: t('cantons.baselLandschaft'),
  },
  {
    value: 'SH',
    label: t('cantons.schaffhausen'),
  },
  {
    value: 'AR',
    label: t('cantons.appenzellAusserrhoden'),
  },
  {
    value: 'AI',
    label: t('cantons.appenzellInnerrhoden'),
  },
  {
    value: 'SG',
    label: t('cantons.stGallen'),
  },
  {
    value: 'GR',
    label: t('cantons.grisons'),
  },
  {
    value: 'AG',
    label: t('cantons.aargau'),
  },
  {
    value: 'TG',
    label: t('cantons.thurgau'),
  },
  {
    value: 'TI',
    label: t('cantons.ticino'),
  },
  {
    value: 'VD',
    label: t('cantons.vaud'),
  },
  {
    value: 'VS',
    label: t('cantons.valais'),
  },
  {
    value: 'NE',
    label: t('cantons.neuchatel'),
  },
  {
    value: 'GE',
    label: t('cantons.geneva'),
  },
  {
    value: 'JU',
    label: t('cantons.jura'),
  },
];
